import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { useAddPopupMessage } from 'src/hooks/ui'
import { useEditReportComponentRequest } from 'src/hooks/api'
import { ReportComponentNewForm } from 'src/components/forms'

interface Props {
  id: number;
  name: string;
  reportComponentDescription?: string;
  order?: number;
  divider?: boolean;
  onChange: () => void;
  onCancel: () => void;
}

export const EditableReportComponent: FC<Props> = ({
  id,
  name,
  reportComponentDescription,
  order,
  divider,
  onChange,
  onCancel,
}) => {
  const addMessage = useAddPopupMessage()
  const editReportComponentRequest = useEditReportComponentRequest({ id })

  const update = ({ displayName, description, order: sbmOrder, divider: sbmDivider }: { displayName: string, description?: string, order?: number, divider?: boolean }) => {
    editReportComponentRequest.mutate(
      { displayName, description: description || '', order: sbmOrder, divider: sbmDivider },
      {
        onSuccess: onChange,
        onError: (error) => addMessage({ type: 'error', text: error.message }),
      }
    )
  }

  return (
    <>
      <Grid item flexGrow={1}>
        <ReportComponentNewForm
          onSubmit={update}
          initialValues={{ displayName: name, description: reportComponentDescription, order, divider }}
          onCancel={onCancel}
          isLoading={editReportComponentRequest.isLoading}
        />
      </Grid>
    </>
  )
}